let mutations = {
    wxUserAuthInfo(state, data) {
        // 变更状态
        
    },
    wxTokenMutation(state, data) {
        state.appId = data.appId;
    },
    wxtoken21DaysMutation(state, data) {
        state.appId = data.appId;
    },
    wxtokenMiniappMutation(state, data) {
        state.appId = data.appId;
    }
}
export default mutations;


// WEBPACK FOOTER //
// ./src/vuex/modules/wxAuth/mutations.js